import clsx from "clsx";

const bgcolors = {
  "transparent" : "transparent",
	"white": "bg-white",
	"gray": "bg-gray-50",
  "yellow": "bg-yellow/10",
  "green": "bg-green/10",
  "red" : "bg-red/10",
  "blue" : "bg-info-20/15",
  "yellow-link": "bg-yellow/10 transition ease-in-out",
  "green-link": "bg-green/10 transition ease-in-out",
  "red-link" : "bg-red/10 transition ease-in-out",
  "blue-link" : "bg-info-20/15 transition ease-in-out",
  "primary": "bg-primary-50/30"
};

const structures = {
	"center": "flex-col items-center text-center",
  "center-row": "flex-col md:flex-row items-center text-center",
	"left": "flex-col text-left",
  "left-row": "flex-col md:flex-row text-left"
}

const roundeds = {
	"none": "",
	"sm": "rounded-sm",
	"md": "rounded-md",
	"lg": "rounded-lg",
  "2xl": "rounded-2xl",
	"full": "rounded-full"
}

export interface Props extends Record<string, any>{
  className?: string;
  href?: string;
  target?: '_self' | '_blank';
  bgColor?: string;
  structure?: keyof typeof structures;
  rounded?: keyof typeof roundeds;
  border?: boolean;
  space?: string;
  children?: React.ReactNode;
}

export default function Cards({className = "", href, bgColor = "white", border=false, rounded = "lg", target="_self", space = "px-5 py-7.5", structure = "left", children, ...props}:Props) {
  const Tag = href ? 'a': 'div';
  return (
    <Tag className={clsx(
      `flex`,
      !!href && '[&:hover_.title.black]:decoration-black [&:hover_.title]:decoration-primary [&:hover_.title]:underline [&:hover_.title]:underline-offset-4 [&:hover_.title]:decoration-1 [&_.title]:transition [&_.title]:duration-1000 hover:shadow-xl transition duration-300',
      Object.keys(bgcolors).includes(bgColor) ? bgcolors[bgColor as keyof typeof bgcolors] : bgColor,
      structures[structure],
      roundeds[rounded],
      space,
      className,
      border && "border"
    )} href={href} target={target} {...props}>
      {children}
    </Tag>
  );
}